"use client";

import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import { usePathname, useRouter } from "next/navigation";
import { useState } from "react";
import { Locales } from "@/lib/i18n";
import { isEditSlug, isOrdersSlug } from "./account-sidebar";

type AccoutViewFilterProps = {
  links: {
    label: string;
    link: string;
  }[];
  currentSlug: string;
  slugs: string[];
  locale: Locales;
};

const AccoutViewFilter = ({ links, currentSlug, slugs, locale }: AccoutViewFilterProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const [selectedAction, setSelectAccountAction] = useState<string>();
  const [isNavigating, setIsNavigating] = useState(false);

  const handleActionChange = (link: string) => {
    if (pathname === link) return;
    setIsNavigating(true);
    setSelectAccountAction(links.find((l) => l.link === link)?.label);
    router.replace(link);
  };

  const getSelectedLink = () => {
    for (let index = 0; index < links.length; index++) {
      const link = links[index];
      const linkSlug = link.link.split("/").pop();

      if (index === 0) {
        if (currentSlug === linkSlug || isEditSlug(locale, currentSlug)) {
          return link;
        }
      } else if (index === 3) {
        if (
          currentSlug === linkSlug ||
          isOrdersSlug(locale, currentSlug) ||
          (slugs.length > 1 && slugs[0] === linkSlug)
        ) {
          return link;
        }
      } else {
        if (currentSlug === linkSlug) {
          return link;
        }
      }
    }
    return links.find((l) => l.link === pathname);
  };

  const selectedLink = getSelectedLink();

  return (
    <form className="lg:hidden">
      <Select onValueChange={(value) => handleActionChange(value)} disabled={isNavigating}>
        <SelectTrigger className="border-primary-light/50 flex h-12.5 w-full bg-white text-sm font-medium">
          {isNavigating ? (
            <div className="flex items-center gap-2 capitalize">
              <Loader2 className="size-4 animate-spin" />
              {selectedAction}
            </div>
          ) : (
            <SelectValue placeholder={selectedLink?.label} />
          )}
        </SelectTrigger>
        <SelectContent>
          {links.map((link, index) => (
            <SelectItem key={index} className="flex w-full" value={link.link}>
              <div className="text-dark-primary flex w-full flex-1 cursor-pointer items-center justify-between px-2.5 py-1 font-semibold transition-all duration-200 ease-in-out hover:bg-[#fafaf9]">
                {link.label}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </form>
  );
};

export default AccoutViewFilter;
